module.exports = __webpack_public_path__ + "static/HyGenius_Logo-f03a6a0908e76103c6c4a698a7a833dc.png";